import { integrationList } from '@repo/common/constants/integration/integrations';
import { useIntegration } from '.';

export function useAccessRequestEnabled(integrationId: string) {
	const { data: integration } = useIntegration({
		id: integrationId,
		options: {
			enabled: !!integrationId,
		},
	});

	const integrationSupportsDataAccessRequest = integrationList.find(
		(localIntegration) =>
			integration &&
			localIntegration.type === integration.type &&
			localIntegration.supportsDataAccessRequests
	);

	return (
		!!integration?.access_request_enabled &&
		integrationSupportsDataAccessRequest
	);
}
